import React from 'react';
import styled from 'styled-components';

import { SkeletonText, gridConfig, BrandLogos, MarketingCard as MarketingCardComponent } from '@tvg/fuse-design';
import { SiteName } from 'types/Site';
import BrandTypes from 'constants/brand';

const StyledMarketingCard = styled(MarketingCardComponent)`
  flex-direction: column;
  margin-bottom: var(--spacing-space24);
`;

const SkeletonLink = styled(SkeletonText)`
  height: var(--font-line-height-m3);

  @media (min-width: ${gridConfig.xl.minWidth}) {
    height: var(--font-line-height-m2);
    margin-bottom: var(--spacing-global-space1);
  }
`;

const Divider = styled.span`
  background: var(--color-functional-divider);
  height: 1px;
  margin-bottom: var(--spacing-global-space2);
  margin-top: var(--spacing-global-space5);
  position: relative;
`;

interface SkeletonCardProps {
  site: SiteName;
}

export default function SkeletonCard({ site }: SkeletonCardProps) {
  if (site === BrandTypes.LITTLEWOODS) {
    return (
      <StyledMarketingCard data-testid="littlewoods-skeleton-card">
        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space3',
            bottom: 'space1',
          }}
          width={{
            l: '50%',
            s: '60%',
            m: '60%',
          }}
        />

        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space5',
          }}
          width={{
            l: '70%',
            s: '85%',
            m: '85%',
          }}
        />

        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space3',
            bottom: 'space1',
          }}
          width={{
            l: '60%',
            s: '70%',
            m: '70%',
          }}
        />

        <Divider />

        <SkeletonLink
          margin={{
            top: 'space5',
          }}
          width={{
            l: '45%',
            s: '50%',
            m: '50%',
          }}
        />
      </StyledMarketingCard>
    );
  }

  return (
    <StyledMarketingCard data-testid="verypay-skeleton-card">
      <BrandLogos brand="VeryPay" width="88" alt="Very Pay" />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space5',
          bottom: 'space1',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space3',
          bottom: 'space1',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space3',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space6',
          bottom: 'space2',
        }}
        width={{
          l: '55%',
          s: '75%',
          m: '75%',
        }}
      />

      <Divider />

      <SkeletonLink
        margin={{
          top: 'space5',
        }}
        width={{
          l: '45%',
          s: '50%',
          m: '50%',
        }}
      />
    </StyledMarketingCard>
  );
}
